var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPostAdd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editor/outline/post add"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1035",
    d: "M32.375 14.8216V30.8332C32.375 33.0423 30.5841 34.8332 28.375 34.8332H8.625C6.41586 34.8332 4.625 33.0423 4.625 30.8332V7.1665C4.625 4.95736 6.41586 3.1665 8.625 3.1665H20.7299",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2654",
    d: "M12.3333 11.0835H18.5",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2655",
    d: "M12.3333 19H24.6667",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2656",
    d: "M12.3333 26.9165H24.6667",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2667",
    d: "M27.75 3.1665V12.6665",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2668",
    d: "M32.375 7.9165L23.125 7.9165",
    stroke: "#20CEA5",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPostAdd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/post_add.c5dfb47ae2bd4f2705535c6c594d4700.svg";